/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

async function removeSelectedProductsFromCart(productIds) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: productIds.reduce((updates, productId) => {
          updates[productId] = 0;
          return updates;
        }, {}),
      }),
    });

    if (response.ok) {
      console.log('Selected products removed from the cart.');
      window.location.href = window.themeVariables.routes.cartUrl;
    } else {
      console.error('Failed to remove selected products from the cart.');
    }
  } catch (error) {
    console.error('Error:', error);
  }
}

var removeSelectedButton = document.getElementById('remove-configurator-button');
removeSelectedButton?.addEventListener('click', function () {
  removeSelectedProductsFromCart(window.cart_set_products);
});

addConfiguratorPdp = document.querySelector('.add-configurator-pdp')

addConfiguratorPdp?.addEventListener('click', function () {
  console.log('click');
  let currentStep;
  let sessionStorageData = JSON.parse(sessionStorage.getItem(currentStep)) || [];
  const productData = JSON.parse(this.getAttribute('data-product'));
  const productTags = productData.tags || [];

  productData.selectedId = document.querySelector('.shopify-product-form input[name="id"]').value;

  const storedTemplate = sessionStorage.getItem('lastTemplate');

    switch (storedTemplate) {
      case 'snowboard-configurator':
        if (productTags.includes('Set Snowboard')) {
          currentStep = 'step_1';
          this.href = window.setLinks[1];
        } else if (productTags.includes('Set Bindings')) {
          currentStep = 'step_2';
          this.href = window.setLinks[2];
        } else if (productTags.includes('Set Boots')) {
          currentStep = 'step_3';
          this.href = window.setLinks[3];
        } else if (productTags.includes('Set Other')) {
          currentStep = 'step_4';
          this.href = window.setLinks[3];
        } else {
          console.log('Fix product tags');
          return;
        }
        break;
      case 'biketricot-configurator':
        if (productTags.includes('Set Fahrradhose')) {
          currentStep = 'bike-step_1';
          this.href = window.setBikeLinks[1];
        } else if (productTags.includes('Set Fahrradtrikot')) {
          currentStep = 'bike-step_2';
          this.href = window.setBikeLinks[2];
        } else if (productTags.includes('Set Fahrradweste')) {
          currentStep = 'bike-step_3';
          this.href = window.setBikeLinks[3];
        } else if (productTags.includes('Set Fahrradjacke')) {
          currentStep = 'bike-step_4';
          this.href = window.setBikeLinks[3]
        } else {
          console.log('Fix product tags');
          return;
        }
        break;
      case 'laufset-configurator':
        if (productTags.includes('Set Laufhosen')) {
          currentStep = 'lauf-step_1';
          this.href = window.setLaufLinks[1];
        } else if (productTags.includes('Set Laufshirts')) {
          currentStep = 'lauf-step_2';
          this.href = window.setLaufLinks[2];
        } else if (productTags.includes('Set Laufwesten')) {
          currentStep = 'lauf-step_3';
          this.href = window.setLaufLinks[3];
        } else if (productTags.includes('Set Laufjacken')) {
          currentStep = 'lauf-step_4';
          this.href = window.setLaufLinks[3]
        } else {
          console.log('Fix product tags');
          return;
        }
        break;
      default:
      console.log('Fix product tags or template name');
    } 
  
  console.log('click2');
  
  sessionStorageData = [productData];
  sessionStorage.setItem(currentStep, JSON.stringify(sessionStorageData));
  console.log('added');
})

// Product Feature Icon
$(document).ready(function() {
  var featuresDiv = $(".feature-badge");
  featuresDiv.wrapAll('<div class="features-icon-block"></div>');
});
// Product review title
$(document).ready(function() {
  setTimeout(function() {
    let reviewTitle = $('.shopify-section--apps');
    let reviewClass = reviewTitle.find('.shopify-app-block');
    
    reviewClass.each(function() {
      let reviewSection = $(this).find('div');
      let reviewText = reviewSection.text().trim();
      
      if (reviewText.length > 0) {
        // console.log("Text length:", reviewText.length);
        reviewTitle.find('.apps-title').removeAttr('hidden');
      }
    });
  }, 500);

  // Infinte Scroll Product on collection page
  if (typeof Ajaxinate !== 'undefined') {
    var ajaxinate = new Ajaxinate({
        method: 'scroll', // or 'click' for a "Load More" button
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        offset: 0, // Adjust as needed
        loadingText: 'Loading..', // Optional loading text
        callback: function () {
          var productItems = document.querySelectorAll('#AjaxinateContainer .product-item');
          productItems.forEach(function(item) {
            item.style.opacity = '1';
          });
        }
    });
  }

});

// Function to update metafield visibility
function updateMetafieldVisibility(variantID) {
    let metafieldVariants = document.querySelectorAll('.custom_metafield ul li');
    let matchFound = false;
    metafieldVariants.forEach(function(Metafieldvariant) {
        let MetavariantID = Metafieldvariant.getAttribute('variant-id');
        if (MetavariantID && variantID) {
            if (MetavariantID == variantID) {
                Metafieldvariant.removeAttribute('hidden');
                matchFound = true;
            } else {
                Metafieldvariant.setAttribute('hidden', '');
            }
        }
    });
}

// Event listener for variant changes
document.addEventListener('variant:changed', function(event) {
    let variantID = event.detail.variant.id;
    updateMetafieldVisibility(variantID);
});

// On page load, find the initial variant and update metafield visibility
document.addEventListener('DOMContentLoaded', function() {
    let initialVariantElement = document.querySelector('.product-form__buy-buttons [name="id"]');
    if (initialVariantElement) {
        let initialVariantID = initialVariantElement.value;
        updateMetafieldVisibility(initialVariantID);
    }
});
